import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-commercial',
	templateUrl: './commercial.component.html',
	styleUrls: ['./commercial.component.scss']
})
export class CommercialComponent implements OnInit {

	presidentList: any = "";
	presidentgeneralList: any = "";
	contactRequest: any = {};
	contactError: any;
	contactSuccess: any;
	bannerrequest: any = {};
	bannerList: any = "";

	constructor(private allpagesService: AllPageService,) { }

	ngOnInit() {
		this.loadBanner();
		this.allpagesService.getCommercialPresident().then((data) => {
			this.presidentList = data;
			this.presidentgeneralList = data.data.general[0];
			//console.log(this.presidentList);
		});
	}

	clubContactus(form: NgForm) {
		if (form.valid) {

			let request: any = {};
			request = Object.assign({}, this.contactRequest);
			this.allpagesService.getClubContactus(request).then((res) => {

				if (res.status == 0) {
					this.contactError = res.message;
				} else {
					this.contactSuccess = res.message;
					form.reset();
				}
			})
				.catch((err) => {
					this.contactError = err.res.message;
				});
		}
	}

	loadBanner() {
		this.bannerrequest = {
			title: "President's and Captain's Club"
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

}
